import "lodash";
import { svc_search, svc_fetchAll, svc_addOne, svc_editOne, svc_deleteOne } from "@/services/";
import logger from "@/utils/logger";
import { convertISODateTimeToString } from "@/utils/convertTime";
import { showServerResponse } from "@/utils/message";

const endpointBasePrefix = "policies";

const Model = {
	namespace: "m_Policy",
	state: {
		policy: [],
		groupPolicies: [],
	},
	reducers: {
		updateModelState(state, { payload: { policy } }) {
			return { ...state, policy };
		},
		updateGroupPolicies(state, { payload: { groupPolicies } }) {
			return { ...state, groupPolicies };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			let response = yield call(svc_fetchAll, endpointBasePrefix, payload);
			if (!showServerResponse(response, true));
			logger("** @effects - fetchAll: " + JSON.stringify(response), 6);
			_.forEach(response.result, (row) => {
				row.policy = row.key;
				row.key = row.id;
				row = convertISODateTimeToString(row, ["created_at"]);
			});
			yield put({
				type: "updateModelState",
				payload: { policy: response },
			});
			return response;
		},
		*fetchOne({ payload }, { call, put }) {
			let response = yield call(svc_fetchAll, `policy_group_xref/${payload.name}`, payload);
			if (!showServerResponse(response, true));
			logger("** @effects - fetchOne: " + JSON.stringify(response), 6);
			_.forEach(response.result, (row) => {
				row.policy = row.key;
				row.key = row.id;
				row = convertISODateTimeToString(row, ["created_at"]);
			});
			yield put({
				type: "updateGroupPolicies",
				payload: { groupPolicies: response },
			});
			return response;
		},
		*addOne({ payload }, { call, put }) {
			payload.key = payload.policy;
			payload = _.omit(payload, ["policy"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload);
			return showServerResponse(response);
		},
	},
};

export default Model;
